import { AnalyticsEventName, reportUsage } from '@ms/yammer-data/dist/telemetry';
import { useTranslations } from '@ms/yammer-i18n-react';
import NavigationStrings from '@ms/yammer-strings/dist/Navigation';
import { questionsPageUrl } from '@ms/yammer-web-support/dist/urls';
import { useCallback, useMemo } from 'react';

import { usePageUrlClick } from '../../../navigation/SubHeader/hooks/usePageUrlClick';
import { VivaEngageNavigationHeaderPivotItem } from '../types';

type UseQnAPivotItem = () => VivaEngageNavigationHeaderPivotItem;
export const useQnAPivotItem: UseQnAPivotItem = () => {
  const t = useTranslations(NavigationStrings);
  const onPageUrlClick = usePageUrlClick();
  const reportAndRedirectToQuestionsPage = useCallback(() => {
    reportUsage({
      eventName: AnalyticsEventName.AnswersTabClicked,
    });
    onPageUrlClick(questionsPageUrl);
  }, [onPageUrlClick]);

  return useMemo(
    () => ({
      key: questionsPageUrl,
      onClick: reportAndRedirectToQuestionsPage,
      text: t.appNavigationQuestions(),
    }),
    [reportAndRedirectToQuestionsPage, t]
  );
};
